import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SendSNOService {

    constructor(private httpClient: HttpClient) { }

    sendSNOPZO(sno: { Email: String, Mobile: String, SendDestination: Number }) {
        return this.httpClient.post('api/sno/sendsnopzo', sno).toPromise();
    }

    sendSNOKomDom(sno: { Email: String, Mobile: String, SendDestination: Number }) {
        return this.httpClient.post('api/sno/sendsnokomdom', sno).toPromise();
    }

}